import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { MESSAGE_MODALS } from '../../../context/custom/MessageModalContext';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, } from '../../common';
import { getDateToString, getFormatNumber  } from '../../../utils/convert';
import { useEntidad } from '../../hooks/useEntidad';
import EspacioArrendadoModal from '../EspacioArrendadoModal';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import { isNull } from '../../../utils/validator';
import { useManagedContext } from '../../hooks';

const EspaciosArrendadoGrid = (props) => {
  const { showMessageModal } = useManagedContext();

  //#region Hooks
  const [state, setState] = useState({
      idComercio: 0,
      disabled: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      dataTagger: {
        showModal: false,
        idEntidad: null
      },      
      list: []
  });

  const [espaciosArrendado, setEspaciosArrendado] = useState([]);

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
      const list = props.data.list.filter(x => x.state !== 'r');
      return {...prevState,
        idComercio: props.data.idComercio,
        list: list };
    });

  }
  useEffect(mount, [props.data]);

  const [, getRowEntidad] = useEntidad({
    entidades: ['TipoArrendamiento'],
    onLoaded: (entidades, isSuccess, error) => {
      if (isSuccess) {
        setState(prevState => ({...prevState}));
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'TipoArrendamiento',
      timeout: 0
    }
  });

  const getDescTipoArrendamiento = (id) => {
    const row = getRowEntidad('TipoArrendamiento', id);
    return (row) ? row.nombre : '';
  }
  //#endregion


  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickEspacioArrendadoAdd() } className="link">
                                      <span className="material-symbols-outlined" title="nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickEspacioArrendadoView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickEspacioArrendadoModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickEspacioArrendadoRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  <div onClick={ (event) => handleClickEspacioArrendadoDataTagger(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>
                              </div>

  const tableColumns = [

    { Header: 'Número', accessor: 'numero', width: '10%'},
    { Header: 'Tipo arrendamiento', Cell: (props) => getDescTipoArrendamiento(props.value), accessor: 'idTipoArrendamiento', width: '40%' },
    { Header: 'Bloque', accessor: 'bloque', width: '10%'},
    { Header: 'Vigencia desde', Cell: (data) => (data.value) ? getDateToString(data.value, false) : '', accessor: 'fechaVigenciaDesde', width: '10%' },
    { Header: 'Vigencia hasta', Cell: (data) => (data.value) ? getDateToString(data.value, false) : '', accessor: 'fechaVigenciaHasta', width: '10%' },

    
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];

  //#region Handles
  const handleClickEspacioArrendadoAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idComercio: state.idComercio,
        idTipoArrendamiento: 0,
        numero: "",
        bloque: "",
        fechaVigenciaDesde: null,
        fechaVigenciaHasta: null,
        fechaBaja: null,
        superficie: 0,
        longitud: 0,
        idTipoConsumoElectrico: 0,
        cantidadArtefactosElectricos: 0,
        numeroResolucion: "",
        nombreEmbarcacion: "",
        matriculaEmbarcacion: "",
        idTasaEmbarcacion: 0,
        idSubTasaEmbarcacion: 0,
        eslora: 0,
        manga: 0,
        puntal: 0,
        pesoNeto: 0,
        pesoBruto: 0,
        pesoLastre: 0,
        state: 'a'
  };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    setEspaciosArrendado(state.list.map(x => x.numero));
    dispatch( sequenceActionNext() );
  }
  const handleClickEspacioArrendadoView = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickEspacioArrendadoModify = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    setEspaciosArrendado(state.list.filter(x => x.id !== id).map(x => x.numero));
  }
  const handleClickEspacioArrendadoRemove = (id) => {
    const espacioArrendado = state.list.find(x => x.id === id);
    showMessageModal({
      ...MESSAGE_MODALS.BORRAR,
      message: `¿Está seguro de borrar el espacio arrendado ${espacioArrendado.numero}?`,
      onConfirm: () => {
        props.onChange('EspacioArrendado', { ...espacioArrendado, state: 'r' })
      }
    })
  }

  const handleClickEspacioArrendadoDataTagger = (id) => {
    setState(prevState => {
      return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
    });
  }
  //#endregion

  //funciones
  function UpdateEspacioArrendado(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('EspacioArrendado', row);
  }

  return (
  <>

    {state.dataTagger.showModal &&
      <DataTaggerModalRedux
          title="Información adicional del espacio arrendado"
          processKey={props.processKey}
          entidad="EspacioArrendado"
          idEntidad={state.dataTagger.idEntidad}
          disabled={props.disabled}
          onDismiss={() => {
            setState(prevState => {
              return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
            });
          }}
      />
    }

    {state.showForm && 
        <EspacioArrendadoModal
            processKey={props.processKey}
            disabled={!state.modeFormEdit}
            data={{
              entity: state.rowForm,
              list: espaciosArrendado
            }}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateEspacioArrendado(row);
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
    />

  </>
  );
}

EspaciosArrendadoGrid.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

EspaciosArrendadoGrid.defaultProps = {
  disabled: false
};

export default EspaciosArrendadoGrid;